import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "mask0_1886_6617",
      style: {"mask-type":"alpha"},
      maskUnits: "userSpaceOnUse",
      x: "3",
      y: "3",
      width: "58",
      height: "58"
    }, [
      _createElementVNode("rect", {
        x: "3",
        y: "3",
        width: "58",
        height: "58",
        fill: "#D9D9D9"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#mask0_1886_6617)" }, [
      _createElementVNode("path", {
        d: "M23.9042 57.375L19.3126 49.5208L10.1897 47.6479L11.2167 38.7667L5.41675 32L11.2167 25.2938L10.1897 16.4125L19.3126 14.5396L23.9042 6.625L32.0001 10.3708L40.0959 6.625L44.748 14.5396L53.8105 16.4125L52.7834 25.2938L58.5834 32L52.7834 38.7667L53.8105 47.6479L44.748 49.5208L40.0959 57.375L32.0001 53.6292L23.9042 57.375ZM25.5355 52.6021L32.0001 49.8833L38.6459 52.6021L42.6938 46.5604L49.7626 44.7479L49.0376 37.5583L53.9313 32L49.0376 26.3208L49.7626 19.1313L42.6938 17.4396L38.5251 11.3979L32.0001 14.1167L25.3542 11.3979L21.3063 17.4396L14.2376 19.1313L14.9626 26.3208L10.0688 32L14.9626 37.5583L14.2376 44.8688L21.3063 46.5604L25.5355 52.6021ZM29.4022 40.0354L43.1167 26.4417L40.398 23.9646L29.4022 34.8396L23.6626 28.8583L20.8834 31.5771L29.4022 40.0354Z",
        fill: "#002565"
      })
    ], -1)
  ])))
}
export default { render: render }